package com.shadowings.gero.data.lessons.chapter1
import com.shadowings.gero.data.lessons.buildHieroQuizContent
import com.shadowings.gero.data.lessons.chapter5.toHieroList
import com.shadowings.gero.data.lessons.toHieroExplanation


import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_ecco_un_secondo_giro_di_simboli
import gero.composeapp.generated.resources.exp_title_introduzione
import gero.composeapp.generated.resources.swipe_up

fun getUni2Content(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IExplanation> {
    val signs = famousNames.toHieroList(words).drop(8)

    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_introduzione,
            content = Res.string.exp_content_ecco_un_secondo_giro_di_simboli,
            face = Faces.Happy,
            image = Res.drawable.swipe_up,
            imageSize = 0.35f,
        ),
    ) + signs.toHieroExplanation(hiero, languageCode)
}

fun getUni_2QuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    return buildHieroQuizContent(
        hiero = hiero,
        hieroContent = getUni2Content(hiero, words, languageCode),
        languageCode = languageCode,
        previousHieroContent = listOf()
    )
}